<template>
  <BaseItem
    v-if="tradeIn"
    :description="tradeIn"
    image="IconSwap"
    :label="i18n(translations.tradeIn)"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import BaseItem from '../BaseItem/BaseItem.vue'

import translations from './TradeIn.translations'

const i18n = useI18n()

defineProps<{
  tradeIn: string | null
}>()
</script>
